import { BrowserModule } from '@angular/platform-browser';
import { NgModule, provideZoneChangeDetection } from "@angular/core";
import { StoreModule } from '@ngrx/store';
import 'reflect-metadata';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { reducers } from './store/app.reducers';
import { EffectsModule } from '@ngrx/effects';
import { AuthEffects } from './auth/store/auth.effects';
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../environments/environment';
// import { GlobalErrorHandlerService } from './shared/global-error-handler-service.service';


@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    CoreModule,
    StoreModule.forRoot(reducers),
    EffectsModule.forRoot([AuthEffects]),
    !environment.production ? StoreDevtoolsModule.instrument({connectInZone: true}) : []
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    provideZoneChangeDetection({ eventCoalescing: true }),
    // GlobalErrorHandlerService, { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
              ],
  bootstrap: [AppComponent]
})
export class AppModule { }
